// extracted by mini-css-extract-plugin
export default {"container":"container-cy06a"};